<template>
    <button
        :disabled = "disabled"
        class="cprm-btn"
        :data-type="type"
        :data-icon="icon">
            <img v-if="icon" src="" alt="">
            <slot></slot>
    </button>
</template>

<script>
export default {
    name: 'Button',
    props: {
        type: {
            type: String,
            default: 'text'
        },
        icon: String,
        disabled: Boolean
    }
}
</script>

<style lang="scss" scpoed>
@import '../../assets/scss/variables.scss';

body button.cprm-btn {
    transition: all 0.2s ease;
    
    &.priceStartNow {
        background: $c14;
        font-size: 16px;
        color: $c1;
        font-weight: $weight_bold;
        transition: all 0.2s linear;
        border-radius: 5px;
        &:not(.purple-on-hover):hover {
            background: $c2;
            color: $c14;
            box-shadow: 0px 16px 24px rgba(8, 35, 48, 0.08), 0px 6px 12px rgba(8, 35, 48, 0.14);
        }

        &.purple-on-hover:hover {
            background: #ebecf0!important;
        }
    }

    &[data-type="pricing-trial"] { 
        color: $c1;
        border: 1px solid $c1;
        font-weight: $weight_bold;
        font-size: 16px;
        border-radius: 5px;
        &:hover {
            background: $c1;
            color: $c14;
            font-family: 'Eina SemiBold';
        }
    }

    &[data-type="gray"] { 
        font-weight: $weight_bold;
        border-radius: 5px;
        background: #E2E8F0;
        &:hover {
            box-shadow: 0px 12px 12px -6px rgba(113, 128, 150, 0.16), 0px 0px 1px rgba(113, 128, 150, 0.2);
        }
    }


            
    &[data-type="pendings-modal"] {
        background: $c1;
        color: $c14;
        font-weight: bold;
        font-size: 16px;
        padding: 12px 96px 12px 96px;
        border-radius: 5px;
        transition: all 0.2s linear;
        &:hover {
            box-shadow: 0px 4px 8px rgba(114, 124, 245, 0.45);
        }
    }
    &[data-type="landing-btn"] {
        background: $c1;
        font-size: 18px;
        border-radius: 5px;
        color: $c14;
        font-weight: $weight_bold;
        transition: all 0.2s linear;
        &:hover {
            box-shadow: 0px 4px 8px rgba(114, 124, 245, 0.45);
        }
    }
    &[data-type="landing-white"] {
        width: 200px;
        height: 48px;
        color: $c1;
        font-weight: $weight_bold;
        font-size: 16px;
        border-radius: 5px;
        background: $c14;
    }  
    &[data-type="landing-green"] {
        font-family: 'Eina Bold';
        padding: 12px 56px 12px 56px;
    }
    &[data-type="landing-green"], &[data-type="button-green"] {
        background: $c2;
        font-size: 16px;
        border-radius: 5px;
        color: $c14;
        transition: all 0.1s linear;
    
        &:hover {
            background: #0ACF97 !important;
            box-shadow: 0px 4px 10px rgba(10, 207, 151, 0.39);
            border-radius: 5px;
            border: 0 !important;
            outline: 0 !important;
        }
    }
    &[data-type="accept"], &[data-type="decline"] { 
        border-radius: 5px;
        transition: all 0.2s ease;
        background: $c14;
        margin: 0 !important;
    }
    &[data-type="decline"] {
        color: #718096;
        border: 1px solid #718096;
        transition: all 0.2s ease;
        &:hover {
            background: #718096 !important;
            color: $c14;
        }
    }
    &[data-type="accept"] {
        color: $c2;
        border: 1px solid $c2;
        margin-right: 8px !important;
        &:hover {
            background: $c2;
            color: $c14;
        }
    }
    &[data-type="request_button"] {
        color: $c14;
        background: linear-gradient(142.56deg, #727CF5 5.45%, #4CC0EC 74.58%);
        border-radius: 5px;
        &:hover {
            box-shadow: 0px 5px 20px rgba(80, 184, 237, 0.46);
        }
    }
    &[data-type="small_primary"] {
        color: $c14;
        background: $c1;
        font-size: $p4;
        border-radius: 5px;
        &:hover {
            box-shadow: 0px 4px 8px rgba(114, 124, 245, 0.45);
        }
    }
    &[data-type="primary"] {
        color: $c14;
        background: $c1;
        font-weight: $weight_bold;
        border-radius: 5px;
        padding: 12px 0;
        &:hover {
            box-shadow: 0px 4px 8px rgba(114, 124, 245, 0.45);
        }
    }
    &[data-type="primary_outline"] {
        border: 1px solid $c1;
        background: $c14;
        color: $c1;
        font-size: $p4;
        border-radius: 5px;
        
        &:hover {
            background: $c1;
            color: $c14;
        }
    }
    &[data-type="info_outline"] {
        border: 1px solid $c2;
        background: $c14;
        color: $c2;
        font-size: $p5;
        border-radius: 5px;
        &:focus {
            border: 1px solid $c2;
        }
        &:hover {
            background: $c2;
            color: $c14;
        }
    }
    &[data-type="download_outline"] {
        // width: 135px;
        // height: 48px;
        color: $c3;
        font-size: $p3;
        font-weight: $weight_bold;
        border-radius: 5px;
        border: 1px solid $c3;

        &:focus {
            border: 1px solid $c3;
        }
        &:hover {
            background: $c3;
            color: $c14;
        }
    }

    // TODO: move to styled components https://github.com/styled-components/vue-styled-components
    // TODO: also consider moving components to chakra-ui for better management of margins, paddings, colors, font sizes etc. https://vue.chakra-ui.com/
    &[data-type="copy"] {
        width: 74px;
        height: 32px;
        color: $c1;
        background: $c14;
        border-radius: 8px;
        margin-right: 3px;
        font-size: $p4;
        font-weight: $weight_bold;
    }
}

</style>
